import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { Dialog } from 'shared/UI/Dialog'
import { CloseButton } from 'shared/UI/CloseButton'
import withKeyEventHandler, { KEY_HANDLERS } from 'shared/hocs/withKeyEventHandler'
import ConfigurableFormPresenter from './ConfigurableFormPresenter'

import './style.css.scss'

const ConfigurableFormDialog = (props) => {
  const FORM_MODAL_CLASSES = {
    bodyOpenClassName: "modal-open",
    overlayClassName: "modal-overlay",
    className: "cta-dialog-container",
    portalClassName: `modal cta-modal ${props.modalClass || ''}`
  }

  useEffect(() => {
    props.provideKeyHandlers && props.provideKeyHandlers({
      [KEY_HANDLERS.esc]: handleCloseDialog
    })
  }, [])

  const handleCloseDialog = (e) => {
    e && e.stopPropagation()
    props.onDone()
    props.onCancel && props.onCancel()
  }

  return (
    <Modal isOpen={true} contentLabel="cta" {...FORM_MODAL_CLASSES} >
      <Dialog
        className={`cta-form-dialog ${props.ctaClass}`}
        onClose={props.onDone}
        showButtons={false}>
          <div className="cta-dialog-content">
            <CloseButton onClose={handleCloseDialog} />
            <ConfigurableFormPresenter
              config={props.config}
              area={props.area}
              onDone={props.onDone}
              itemId={props.itemId}
              ctaClass={props.ctaClass}
              form={props.form}
              themeColorHex={props.themeColorHex} />
          </div>
      </Dialog>
    </Modal>
  )
}

ConfigurableFormDialog.propTypes = {
  config: PropTypes.object.isRequired,
  area: PropTypes.string.isRequired,
  onDone: PropTypes.func,
  onCancel: PropTypes.func,
  itemId: PropTypes.number,
  ctaClass: PropTypes.string,
  form: PropTypes.string,
  themeColorHex: PropTypes.string.isRequired
}

export default withKeyEventHandler(ConfigurableFormDialog)